export const EXCMDEVICEPERIPHERALDEVICE_DELETE_RESET = 'EXCMDEVICEPERIPHERALDEVICE_DELETE_RESET'
export const EXCMDEVICEPERIPHERALDEVICE_DELETE_SET_ERROR = 'EXCMDEVICEPERIPHERALDEVICE_DELETE_SET_ERROR'
export const EXCMDEVICEPERIPHERALDEVICE_DELETE_SET_DELETED = 'EXCMDEVICEPERIPHERALDEVICE_DELETE_SET_DELETED'
export const EXCMDEVICEPERIPHERALDEVICE_DELETE_TOGGLE_LOADING = 'EXCMDEVICEPERIPHERALDEVICE_DELETE_TOGGLE_LOADING'
